export default __webpack_public_path__ + "static/media/css.9a804bba.svg";